
import store from '../../config/store'

export default {
  components: {
    'new-beneficiary-form': () => import(/* webpackChunkName: "beneficiaries" */ '@/common/pages/Beneficiaries/NewBeneficiaryForm.vue')
  },

  data: () => ({
    store,
    sidePanelVue: true,
    beneficiary: {
      rib: null
    }
  }),

  computed: {
    isNoSepaEnabled () {
      return store.sidepanel.hasOwnProperty('dataModel') && store.sidepanel.dataModel.hasOwnProperty('enableNoSepa') ? store.sidepanel.dataModel.enableNoSepa : true
    },

    beneficiaryModel () {
      return store.sidepanel.dataModel.beneficiary || null
    },


  },

  mounted () {
    if (this.beneficiaryModel) {
      Object.assign(this.beneficiary, this.beneficiaryModel)
    }
    this.$bus.$on('local-file-added', this.onRibAttached)
    this.$bus.$on('scrollToTop', this.scrollToTopHandler)
  },

  destroyed () {
    this.$bus.$off('local-file-added', this.onRibAttached)
    this.$bus.$off('scrollToTop', this.scrollToTopHandler)
  },

  methods: {

    addRib () {
      this.showModal({
        childVue: 'join-document',
        wrapperClass: 'modal modal--md',
        dataModel: {
          isLocal: true,
          hasMultipleFiles: false
        },
        autoQueue: false
      })
    },

    onRibAttached (file) {
      this.beneficiary.rib = file
    },

    removeRib () {
      this.beneficiary.rib = null
    },
    
    scrollToTopHandler () {
      this.scrollToTop(this.$refs.sidepanelContent, 300)
    }
  }
}
